import React, { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { DatePicker } from "antd";
import Select from "react-select";
import { Calendar } from "feather-icons-react/build/IconComponents";
import { useSelector } from "react-redux";
import {
  getbillwisepayment,
  getsupBill,
  savebillpayment,
} from "../../services/AccountApiServices";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { BillPaymentEntry } from "../../core/json/BillPaymentEntry";
import { FinancialYear } from "../../core/json/FinancialYear";
import { BillPaymentDetail } from "../../core/json/BillPaymentDetail";
import { Currency } from "../../core/json/Currency";
import { fetchBranchSettings } from "../../redux/settingbyBranch";
import { SupplierClass } from "../../core/json/SupplierClass";
import { getPrintSettingsByBranch } from "../../services/AdminApiServices";

const Billpaymentmodal = ({
  mode,
  data,
  handleClose,
  handleRefresh,
  bankorcash,
}) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      deliveryDate: dayjs().format("YYYY-MM-DD"),
      invdate: dayjs().format("YYYY-MM-DD"),
      isCheque: false,
      amount: 0,
    },
  });
  const isCheque = watch("isCheque");
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const [supBill, setsupBill] = useState([]);
  const [supplier, setSupplier] = useState(null);
  const [amount, setamount] = useState(0);
  const [printSettings, setPrintSettings] = useState([]); 
  
  // const [totals, setTotals] = useState({});
const [printAfterSubmit, setPrintAfterSubmit] = useState(false); // New state variable
  const { formatedsupplierList } = useSelector((state) => state.usersetting);
  const { companyInfolist } = useSelector((state) => state.companyInfo);
  const { userId } = useSelector((state) => state.userauth);
  const { branch } = useSelector((state) => state.branchlist);
  const { branchsettings } = useSelector((state) => state.settings);
  useEffect(() => {
    dispatch(fetchBranchSettings(branch.guid));
  }, [branch]);

  useEffect(() => {
    const fetchPrintSettings = async () => {
      try {
        const response = await getPrintSettingsByBranch(branch?.guid);
        setPrintSettings(response);
      } catch (error) {
        console.error("Failed to fetch print settings", error);
      }
    };
  
    if (branch?.guid) {
      fetchPrintSettings();
    }
  }, [branch]);

  async function handleFill() {
    if (!supplier || amount <= 0) {
      return;
    }
    await handlebill(supplier);

    // const fillamount = amount;

    let remainingAmount = amount;

    if (amount <= totalbalance) {
      fields.forEach((field, index) => {
        const balance = parseFloat(watch(`items[${index}].balance`, 0)) || 0;

        if (remainingAmount > 0) {
          const payingAmount = Math.min(remainingAmount, balance);
          setValue(
            `items[${index}].paying`,
            payingAmount.toFixed(decimalpoints) || 0
          );
          setValue(
            `items[${index}].balance`,
            (balance - payingAmount).toFixed(decimalpoints) || 0
          );
          remainingAmount -= payingAmount;
        }
        if (remainingAmount <= 0) {
          // setValue("amount", 0);
          setamount(0);
        }
      });
    }
  }

  // Get branch from redux
  // Fetch sales quotations data
  const handleEntryNo = async () => {
    try {
      const response = await getbillwisepayment(branch);
      const receiptData = response.data;
      // Find the maximum number from the existing entries
      const maxEntryNumber =
        receiptData?.length > 0
          ? receiptData
              ?.map((data) => parseInt(data.no))
              ?.reduce((max, num) => Math.max(max, num), 0) // Find the maximum number
          : 0;

      let counter = maxEntryNumber + 1;
      setValue(`no`, counter);
      counter++;
    } catch (error) {
      console.error("Failed to fetch purchase invoices", error);
    }
  };

  // function resetmodal() {
  //   if (mode === "edit" && data) {
  //     setValue("no", data.no);
  //     setValue("paymentdate", data.date);
  //     setValue("supplier", data.supplier.guid);
  //     setValue("ledger", data.ledgerID);
  //     setValue("isCheque", data.isCheque);
  //     setamount(data.amount);
  //     // setValue("amount", data.amount);
  //     setValue("remark", data.narration);
  //     const groupedData = data?.billPaymentDetail.reduce((acc, e) => {
  //       const key = e.entryNumber;
  //       if (!acc[key]) {
  //         acc[key] = { ...e, amount: e.amount, discount: e.discount }; // Initialize the group
  //       } else {
  //         acc[key].amount += e.amount; // Sum amounts for the same entryNumber
  //         acc[key].discount += e.discount; // Sum discounts for the same entryNumber
  //       }
  //       return acc;
  //     }, {});
  //     const detail = Object.values(groupedData).map((e) => {
  //       const bal = (e.netTotal - (e.amount + e.discount)).toFixed(2); // Rounds balance to 2 decimal places

  //       // Return the transformed object
  //       return {
  //         masterID: e.masterID,
  //         purchaseMasterID: e.purchaseMasterID,
  //         purchaseReturnMasterID: e.purchaseReturnMasterID,
  //         billtype: e.transType,
  //         billno: e.entryNumber,
  //         // billno: e.purchaseMasterID,
  //         date: dayjs(e.entryDate).format("DD-MM-YYYY"),
  //         billamount: e.netTotal,
  //         paid: e.amount,
  //         paying: e.amount,
  //         discount: e.discount,
  //         invNo: e.invoiceNO,
  //         invdate: dayjs(e.entryDate).format("DD-MM-YYYY"), // Correct usage of dayjs
  //         balance: bal > 0 ? bal : 0,
  //       };
  //     });

  //     setValue("items", detail);
  //   }
  // }

  async function resetmodal() {
  if (mode === "edit" && data) {
    setValue("no", data.no);
    setValue("paymentdate", data.date);
    setValue("supplier", data.supplier.guid);
    setValue("ledger", data.ledgerID);
    setValue("isCheque", data.isCheque);
    setamount(data.amount);
    setValue("remark", data.narration);

    // 🔹 1. Fetch full supplier bill history to get total paid amounts
    const response = await getsupBill(data.supplier.guid, branch);

    // Create a lookup map of total paid per entryNumber
    const allPayments = {};
    if (Array.isArray(response.data)) {
      response.data.forEach((bill) => {
        const key = bill.entryNumber;
        const totalPaid = (bill.amount || 0) + (allPayments[key]?.paid || 0);
        allPayments[key] = { ...bill, paid: totalPaid };
      });
    }

    // 🔹 2. Build detail list for edit mode
    const detail = data?.billPaymentDetail.map((e) => {
      const key = e.entryNumber;
      const fullPaid = allPayments[key]?.paid || 0;
      const bal = (e.netTotal - (fullPaid + e.discount)).toFixed(2);

      return {
        masterID: e.masterID,
        purchaseMasterID: e.purchaseMasterID,
        purchaseReturnMasterID: e.purchaseReturnMasterID,
        billtype: e.transType,
        billno: e.entryNumber,
        date: dayjs(e.entryDate).format("DD-MM-YYYY"),
        billamount: e.netTotal,
        paid: fullPaid, // 👈 use total paid till now
        paying: e.amount,
        discount: e.discount,
        invNo: e.invoiceNO,
        invdate: dayjs(e.entryDate).format("DD-MM-YYYY"),
        balance: bal > 0 ? bal : 0,
      };
    });

    setValue("items", detail);
  }
}

  useEffect(() => {
    resetmodal();
  }, [data, append, remove]);

  useEffect(() => {
    const fetchData = async () => {
      if (mode === "add") {
        handleEntryNo();
        if (!isRowAdded && fields?.length === 0) {
          setIsRowAdded(true);
        }
      }
    };

    fetchData();
  }, []);

  const handlesaveorupdate = async (formData) => {
    const objbillpayment = new BillPaymentEntry();
    const objfinance = new FinancialYear();
    const objcurrency = new Currency();
    const objsupplier = new SupplierClass();
    objfinance.guid = branchsettings?.defaultFinancialYearGuID;
    objfinance.id = branchsettings?.defaultFinancialYearID;
    objcurrency.guid = branchsettings?.primaryCurrencyGUID;
    objbillpayment.guid = mode == "edit" ? data.guid : "";
    objbillpayment.id = mode == "edit" ? data.id : 0;
    objbillpayment.Currency = objcurrency;
    objbillpayment.date = dayjs(formData.invdate).format("YYYY-MM-DD");
    objbillpayment.No = formData.no;
    objsupplier.Guid = formData.supplier;
    objbillpayment.Supplier = objsupplier;
    objbillpayment.Narration = formData.remark;
    objbillpayment.Amount = parseFloat(amount);
    objbillpayment.LedgerID = formData.ledger;
    objbillpayment.Branch = branch;
    objbillpayment.FinancialYear = objfinance;
    objbillpayment.Company = companyInfolist[0];
    objbillpayment.createdUser = userId.id;
    objbillpayment.updatedUser = userId.id;

    for (const {
      select,
      masterID,
      purchaseMasterID,
      purchaseReturnMasterID,
      paying,
      discount,
    } of formData.items) {
      if (select || paying > 0) {
        const objdetail = new BillPaymentDetail();
        objdetail.MasterID = masterID;
        objdetail.PurchaseMasterID = purchaseMasterID;
        objdetail.PurchaseReturnMasterID = purchaseReturnMasterID;
        objdetail.Amount = parseFloat(paying) || 0;
        objdetail.Discount = parseFloat(discount) || 0;
        objbillpayment.billPaymentDetail.push(objdetail);
      }
    }

    try {
      const response = await savebillpayment(objbillpayment);
      if (response.data == true) {
        // fields.forEach((_, index) => remove(index))
        toast.success("success");
        handleClose();
        handleRefresh();
                               if (printAfterSubmit) {
           printA4Function();      // 👈 only called if user clicked "Save & Print"
           setPrintAfterSubmit(false); // reset flag
         }
        }
      } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error("Error handling :", error?.response?.data?.Message);
    }
  };
const printA4Function = () => {
  const formValues = watch();
  const fields = formValues?.items || [];

  // const company = companyInfolist?.[0] || {};
  // const companyName = company.name || "Company Name";
  // const companyAddress1 = company.address1 || "";
  // const companyAddress2 = company.address2 || "";
  // const companyAddress3 = company.address3 || "";
  // const companyPhone = company.phone || "-";
  // const companyEmail = company.email || "-";
  // const companyTIN = company.tin || "-";

  const company = printSettings?.[0] ?? {};

console.log("Company Info for Printing:", company); 
    // Extract company details
    const companyName = company.companyName;
    const otherLanguage = company.otherLanguage || "";
    const companyAddress1 = company.header1 || "";
    const companyAddress2 = company.header2 || "";
    const companyAddress3 = company.header3 || "";
    const companyAddress4 = company.header4 || "";
    const companyAddress5 = company.header5 || "";

  const entryNumber = formValues.no || "-";
  const paymentDate = formValues.paymentdate
    ? dayjs(formValues.paymentdate).format("DD/MM/YYYY")
    : dayjs().format("DD/MM/YYYY");
  const supplierName =
    formatedsupplierList?.find((s) => s.value === formValues.supplier)?.label || "-";
  const ledgerObj = bankorcash?.find((l) => l.value === formValues.ledger);
  const ledgerName = ledgerObj?.label || "-";
  const paymentMode = ledgerObj?.mode || "Cash";
  const remark = formValues.remark || "-";

  // Totals
  const totalBillAmount = fields.reduce((acc, row) => acc + parseFloat(row.billamount || 0), 0);
  const totalPaid = fields.reduce((acc, row) => acc + parseFloat(row.paid || 0), 0);
  const totalPaying = fields.reduce((acc, row) => acc + parseFloat(row.paying || 0), 0);
  const totalDiscount = fields.reduce((acc, row) => acc + parseFloat(row.discount || 0), 0);
  const totalBalance = fields.reduce((acc, row) => acc + parseFloat(row.balance || 0), 0);

  const tableRows = fields
    .filter((row) => parseFloat(row.paying) > 0 || parseFloat(row.discount) > 0)
    .map((row, index) => {
      return `
        <tr>
          <td>${index + 1}</td>
          <td>${row.billno || "-"}</td>
          <td>${row.invNo || "-"}</td>
          <td>${row.date || "-"}</td>
          <td style="text-align:right;">${parseFloat(row.billamount || 0).toFixed(2)}</td>
          <td style="text-align:right;">${parseFloat(row.paid || 0).toFixed(2)}</td>
          <td style="text-align:right;">${parseFloat(row.paying || 0).toFixed(2)}</td>
          <td style="text-align:right;">${parseFloat(row.discount || 0).toFixed(2)}</td>
          <td style="text-align:right;">${parseFloat(row.balance || 0).toFixed(2)}</td>
        </tr>
      `;
    });

  const chequeDetails =
    paymentMode.toLowerCase() === "cheque"
      ? `
        <tr>
          <td><strong>Cheque No:</strong></td>
          <td>${formValues.chequeNo || "-"}</td>
        </tr>
        <tr>
          <td><strong>Cheque Date:</strong></td>
          <td>${formValues.chequedate ? dayjs(formValues.chequedate).format("DD/MM/YYYY") : "-"}</td>
        </tr>
        <tr>
          <td><strong>Bank Name:</strong></td>
          <td>${formValues.bankName || "-"}</td>
        </tr>
        <tr>
          <td><strong>Branch:</strong></td>
          <td>${formValues.branchName || "-"}</td>
        </tr>
      `
      : "";

  const printableContent = `
  <html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
          font-size: 12px;
          margin: 20px;
        }
        h2, h3 {
          margin: 0;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 15px;
        }
        th, td {
          border: 1px solid #000;
          padding: 6px;
        }
        .header {
          text-align: center;
        }
        .info-table td {
          border: none;
          padding: 4px;
          text-align: left;
        }
        .totals-table {
          width: 35%;
          border-collapse: collapse;
          margin-top: 15px;
          float: right;
        }
        .totals-table td {
          border: 1px solid #000;
          padding: 6px;
          font-size: 12px;
          text-align: right;
        }
        .totals-table td.label {
          text-align: left;
          width: 70%;
        }
      </style>
    </head>
    <body>
      <div class="header">
   <h2>${otherLanguage}</h2>
  <h2>${companyName}</h2>
 
  <p>${companyAddress1}</p>
  <p>${companyAddress2}</p>
  <p>${companyAddress3}</p>
  <p>${companyAddress4}</p>
  <p>${companyAddress5}</p>
      </div>

      <h3 style="text-align:center; margin-top:10px;">BILL WISE PAYMENT</h3>

      <table class="info-table">
        <tr>
          <td><strong>Voucher No:</strong> ${entryNumber}</td>
          <td><strong>Date:</strong> ${paymentDate}</td>
        </tr>
        <tr>
          <td><strong>Supplier:</strong> ${supplierName}</td>
          <td><strong>Paid Through:</strong> ${ledgerName}</td>
        </tr>
        ${chequeDetails}
        <tr>
          <td colspan="2"><strong>Remarks:</strong> ${remark}</td>
        </tr>
      </table>

      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Bill No</th>
            <th>Invoice No</th>
            <th>Date</th>
            <th>Bill Amount</th>
            <th>Paid</th>
            <th>Paying</th>
            <th>Discount</th>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows.join("")}
        </tbody>
      </table>

      <table class="totals-table">
        <tr>
          <td class="label">Total Bill Amount:</td>
          <td>${totalBillAmount.toFixed(2)}</td>
        </tr>
        <tr>
          <td class="label">Total Paid:</td>
          <td>${totalPaid.toFixed(2)}</td>
        </tr>
        <tr>
          <td class="label">Total Paying:</td>
          <td>${totalPaying.toFixed(2)}</td>
        </tr>
        <tr>
          <td class="label">Total Discount:</td>
          <td>${totalDiscount.toFixed(2)}</td>
        </tr>
        <tr>
          <td class="label"><strong>Total Balance:</strong></td>
          <td><strong>${totalBalance.toFixed(2)}</strong></td>
        </tr>
      </table>
    </body>
  </html>
  `;

  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0px";
  iframe.style.height = "0px";
  iframe.style.border = "none";
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(printableContent);
  doc.close();

  iframe.contentWindow.focus();
  setTimeout(() => {
    iframe.contentWindow.print();
    iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
  }, 500);
};

  const handlebill = async (val) => {
    // setValue("amount", "");
    setamount(0);

    try {
      const response = await getsupBill(val, branch);

      if (Array.isArray(response.data)) {
        const groupedData = response.data.reduce((acc, e) => {
          const key = e.entryNumber;
          if (!acc[key]) {
            acc[key] = { ...e, amount: e.amount, discount: e.discount }; // Initialize the group
          } else {
            acc[key].amount += e.amount; // Sum amounts for the same entryNumber
            acc[key].discount += e.discount; // Sum discounts for the same entryNumber
          }
          return acc;
        }, {});

        const data = Object.values(groupedData).map((e) => {
          const bal = (e.netTotal - (e.amount + e.discount)).toFixed(2); // Rounds balance to 2 decimal places

          return {
            masterID: e.masterID,
            purchaseMasterID: e.purchaseMasterID,
            purchaseReturnMasterID: e.purchaseReturnMasterID,
            billtype: e.transType,
            billno: e.entryNumber,
            date: dayjs(e.entryDate).format("DD-MM-YYYY"),
            billamount: e.netTotal,
            paid: e.amount,
            discount: e.discount,
            invNo: e.invoiceNO,
            invdate: dayjs(e.entryDate).format("DD-MM-YYYY"), // Correct usage of dayjs
            balance: bal,
          };
        });

        setValue("items", data);
        setsupBill(data);
      } else {
        setsupBill([]);
      }
    } catch (error) {
      console.error("Error fetching bill data:", error);
      setsupBill([]);
    }
  };
  const totalamount = fields?.reduce(
    (sum, _, index) =>
      sum + parseFloat(watch(`items[${index}].billamount`) || 0),
    0
  );
  const totalpaid = fields?.reduce(
    (sum, _, index) => sum + parseFloat(watch(`items[${index}].paid`) || 0),
    0
  );
  const totalpaying = fields?.reduce(
    (sum, _, index) => sum + parseFloat(watch(`items[${index}].paying`) || 0),
    0
  );
  const totaldiscount = fields?.reduce(
    (sum, _, index) => sum + parseFloat(watch(`items[${index}].discount`) || 0),
    0
  );
  const totalbalance = fields?.reduce(
    (sum, _, index) => sum + parseFloat(watch(`items[${index}].balance`) || 0),
    0
  );

  function handleAddPaying(index) {
    const billamount = getValues(`items[${index}].billamount`) || 0;
    const paid = getValues(`items[${index}].paid`) || 0;
    const paying = getValues(`items[${index}].paying`) || 0;
    const discount = getValues(`items[${index}].discount`) || 0;
    setValue("amount", totalpaying);
    setamount(totalpaying);
    const balance = billamount - paid;
    const finalBalance = balance - paying - discount;

    if (paying && paying > 0) {
      setValue(`items[${index}].select`, true);
    } else {
      setValue(`items[${index}].select`, false);
    }
    if (finalBalance >= 0) {
      setValue(`items[${index}].balance`, finalBalance);
    }
  }

  const checkfield =fields.length > 0 ? false : true
  return (
    <div>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog add-centered">
          <div className="modal-content">
            <div className="page-wrapper p-0 m-0">
              <div className="content p-0">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>
                      {" "}
                      {mode === "edit"
                        ? "Edit Bill Wise Payment"
                        : "Add Bill Wise Payment"}
                    </h4>
                  </div>
                  <button type="button" className="close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit(handlesaveorupdate)}>
                      <div className="row">
                        {/* row1 */}
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">Entry No.</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("no")}
                              required
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label>Date</label>
                            <div className="input-groupicon calender-input">
                              <Calendar className="info-img" />
                              <Controller
                                control={control}
                                name="paymentdate"
                                render={({ field: { onChange, value } }) => (
                                  <DatePicker
                                    className="datetimepicker"
                                    value={value ? dayjs(value) : dayjs()}
                                    format="DD-MM-YYYY"
                                    onChange={(date) =>
                                      onChange(
                                        date ? date.format("YYYY-MM-DD") : null
                                      )
                                    } // Update on change
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks add-product">
                            <label>
                              Supplier<span className="text-danger">*</span>
                            </label>

                            <Controller
                              control={control}
                              name={`supplier`}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={formatedsupplierList}
                                  value={formatedsupplierList?.find(
                                    (customer) => customer?.value === value
                                  )}
                                  onChange={(selectedOption) => {
                                    onChange(selectedOption.value);
                                    setSupplier(selectedOption.value);
                                    handlebill(selectedOption.value);
                                  }}
                                  styles={{
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9999,
                                    }),
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">
                              Ledger<span className="text-danger">*</span>
                            </label>
                            <div className="row">
                              <Controller
                                control={control}
                                name="ledger"
                                rules={{
                                  required: "Selecting a ledger is required", // Validation rule for required
                                }}
                                render={({
                                  field: { onChange, value },
                                  fieldState: { error }, // Access error object to show validation message
                                }) => (
                                  <>
                                    <Select
                                      classNamePrefix="react-select"
                                      options={bankorcash}
                                      value={bankorcash?.find(
                                        (bank) => bank?.value === value
                                      )}
                                      onChange={(selectedOption) =>
                                        onChange(selectedOption?.value)
                                      }
                                      styles={{
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                      }}
                                    />
                                    {error && (
                                      <p className="text-danger">
                                        {error.message}
                                      </p>
                                    )}
                                  </>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <div className="form-check form-switch mt-4">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                {...register("isCheque")}
                              />
                              <label className="form-check-label">
                                Cheque ?
                              </label>
                            </div>
                          </div>
                        </div>

                        {isCheque && (
                          <>
                            {["chequeNo", "accNo", "holdername"].map(
                              (field, index) => (
                                <div
                                  key={index}
                                  className="col-lg-4 col-sm-6 col-12"
                                >
                                  <div className="input-blocks">
                                    <label className="form-label">{`${
                                      field.charAt(0).toUpperCase() +
                                      field.slice(1).replace(/([A-Z])/g, " $1")
                                    }`}</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(field)}
                                      required
                                    />
                                  </div>
                                </div>
                              )
                            )}

                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="input-blocks">
                                <label>Cheque Date</label>
                                <div className="input-groupicon calender-input">
                                  <Calendar className="info-img" />
                                  <Controller
                                    control={control}
                                    name="chequedate"
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <DatePicker
                                        className="datetimepicker"
                                        value={value ? dayjs(value) : dayjs()}
                                        format="DD-MM-YYYY"
                                        onChange={(date) =>
                                          onChange(
                                            date
                                              ? date.format("YYYY-MM-DD")
                                              : null
                                          )
                                        }
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-lg-2 col-sm-6 col-6">
                          <div className="input-blocks">
                            <label className="form-label">Amount</label>
                            <input
                              type="number"
                              min={0}
                              step="any"
                              value={amount}
                              onChange={(e) => setamount(e.target.value)}
                              className="form-control"
                              // {...register("amount", {
                              //   required: "Amount is required",
                              //   validate: {
                              //     withinBalance: (value) =>
                              //       (!isNaN(value) && value <= totalbalance) ||
                              //       "Amount can't be greater than balance",
                              //   },
                              // })}
                            />
                            {amount > totalbalance && (
                              <span className="error text-danger text-sm">
                                Amount cant be greater than balance
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks mt-1">
                            {/* <label className="form-label">Amount</label> */}
                            <button
                              className="btn btn-success mt-4 px-4"
                              onClick={handleFill}
                              type="button"
                            >
                              Fill
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive  no-pagination table-container">
                        <table className="table tablezindbill">
                          <thead>
                            <tr>
                              <th
                                className="sticky-header"
                                style={{ width: "10px" }}
                              >
                                {" "}
                                sl
                              </th>
                              <th className="sticky-header">BillType</th>
                              <th className="sticky-header">BillNo.</th>
                              <th className="sticky-header">Date</th>
                              <th className="sticky-header">Bill Amount</th>
                              <th className="sticky-header">Paid</th>
                              <th className="sticky-header">Paying</th>
                              <th className="sticky-header">Discount</th>
                              <th className="sticky-header">Balance</th>
                              <th className="sticky-header">Inv.No.</th>
                              <th className="sticky-header">Inv.Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {fields?.map((obj, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      {...register(`items[${index}].select`)}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].billtype`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].billno`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].date`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      min={0}
                                      step="any"
                                      className="form-control"
                                      {...register(
                                        `items[${index}].billamount`
                                      )}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      min={0}
                                      step="any"
                                      className="form-control"
                                      {...register(`items[${index}].paid`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      min={0}
                                      step="any"
                                      className="form-control"
                                      // onChange={(e) =>
                                      //   handleAddPaying(index, e.target.value)
                                      // }
                                      {...register(`items[${index}].paying`, {
                                        validate: {
                                          withinBalance: (value) => {
                                            const balance =
                                              getValues(
                                                `items[${index}].billamount`
                                              ) || 0;
                                            const paid =
                                              getValues(
                                                `items[${index}].paid`
                                              ) || 0;
                                            const discount =
                                              getValues(
                                                `items[${index}].discount`
                                              ) || 0;
                                            const amount =
                                              balance - paid - discount;
                                            return (
                                              (!isNaN(value) &&
                                                value <= amount) ||
                                              `Amount can't be greater than balance `
                                            );
                                          },
                                        },
                                        onBlur: (e) => {
                                          handleAddPaying(
                                            index
                                            // e.target.value
                                          ); // Call your custom function
                                        },
                                      })}
                                      // onChange={(e) =>
                                      //   handlebalance(e.target.value, "pay")
                                      // }
                                    />

                                    {errors?.items?.[index]?.paying && (
                                      <span className="error text-danger text-sm">
                                        {errors.items[index].paying.message}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      min={0}
                                      step="any"
                                      className="form-control"
                                      {...register(`items[${index}].discount`, {
                                        validate: {
                                          withinBalance: (value) => {
                                            const balance =
                                              getValues(
                                                `items[${index}].billamount`
                                              ) || 0;
                                            const paid =
                                              getValues(
                                                `items[${index}].paid`
                                              ) || 0;
                                            const paying =
                                              getValues(
                                                `items[${index}].paying`
                                              ) || 0;
                                            const amount =
                                              balance - paid - paying;
                                            return (
                                              (!isNaN(value) &&
                                                value <= amount) ||
                                              `Amount can't be greater than balance ${amount}`
                                            );
                                          },
                                        },
                                        onBlur: (e) => {
                                          handleAddPaying(
                                            index
                                            // e.target.value
                                          );
                                        },
                                      })}
                                    />
                                    {errors?.items?.[index]?.discount && (
                                      <span className="error text-danger text-sm">
                                        {errors.items[index].discount.message}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      min={0}
                                      step="any"
                                      className="form-control"
                                      {...register(`items[${index}].balance`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].invNo`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].invdate`)}
                                      disabled
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td className="text-center border-2">
                                <b>{totalamount || 0}</b>
                              </td>
                              <td className="text-center border-2">
                                <b>{totalpaid || 0}</b>
                              </td>
                              <td className="text-center border-2">
                                <b>{totalpaying || 0}</b>
                              </td>
                              <td className="text-center border-2">
                                <b>{totaldiscount || 0}</b>
                              </td>
                              <td className="text-center border-2">
                                <b>{totalbalance || 0}</b>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div className="row mt-3">
                        <div className="col-12">
                          <div className="input-blocks">
                            <label className="form-label">Remarks</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("remark")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 text-end">
                                                             <button
  type="submit"
  className="btn btn-cancel add-cancel me-3"
  onClick={() => setPrintAfterSubmit(true)} // 👈 set flag before submit
>
  Save & Print
</button>
                          <button
                            type="button"
                            className="btn btn-cancel add-cancel me-3"
                            onClick={resetmodal}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-submit add-sale"
                            type="submit"
                            disabled={checkfield || totalpaying==0  }
                         
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Billpaymentmodal;
